import { Uploads } from './Uploads';

export function Planting() {
  return <Uploads type="planting" />;
}
